<div class="content-wrapper container-xxl p-0">
  <div class="content-body" [ngClass]="{'center-card': !currentUser?.userId}">
    <div class="card mb-0 m-1 m-md-0">
      <div class="card-body p-3 p-md-4">

        <!-- ── Loading: fetching contest ───────────────────────────────── -->
        <ng-container *ngIf="isGettingContestDetails">
          <div class="beewiz-step">
            <div class="contest-banner">
              <div class="contest-banner__mascot">
                <img src="../../../../../assets/img/Group 40086.png" alt="BeeWiz" />
              </div>
              <div class="contest-banner__info">
                <p class="contest-banner__title mb-0">
                  Fetching contest details&hellip;
                  <span class="spinner-border spinner-border-sm ml-1" role="status"></span>
                </p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- ── Contest loaded ──────────────────────────────────────────── -->
        <ng-container *ngIf="!isGettingContestDetails">

          <!-- No contest found -->
          <ng-container *ngIf="!contest?.contestId && !showErrorModal">
            <div class="beewiz-step">
              <div class="contest-banner">
                <div class="contest-banner__mascot">
                  <img src="../../../../../assets/img/Group 40086.png" alt="BeeWiz" />
                </div>
                <div class="contest-banner__info">
                  <p class="contest-banner__title mb-0">{{ errorMessage }}</p>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- ── ANONYMOUS FLOW (BeeWiz national contest) ─────────────── -->
          <ng-container *ngIf="contest?.contestId && isAnonFlow">

            <!-- Step: entry ────────────────────────────────────────────── -->
            <div class="beewiz-step" *ngIf="step === 'entry'">

              <div class="contest-banner">
                <div class="contest-banner__mascot">
                  <img src="../../../../../assets/img/Group 40086.png" alt="BeeWiz mascot" />
                </div>
                <div class="contest-banner__info">
                  <p class="contest-banner__title mb-2">
                    You are about to join a <span class="highlight">Zeraki Contest</span>
                  </p>
                  <p class="contest-banner__subtitle mb-0">
                    Form {{ contest.form }}, {{ contest.subject }} &ndash; {{ contest.title }}
                  </p>
                </div>
              </div>

              <p class="step-heading">Please enter your name below to continue</p>

              <form [formGroup]="joinContestForm">
              <div class="entry-inputs">
                <!-- Full name -->
                <div class="input-field-group">
                  <label class="input-label">Enter your full name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="e.g. ANN NDUNGU"
                    formControlName="displayName"
                    [class.input-error]="submitted && f.displayName.errors"
                  />
                  <small class="text-danger" *ngIf="submitted && f.displayName.errors?.required">
                    Please enter your full name
                  </small>
                </div>

                <!-- School search -->
                <div class="input-field-group">
                  <label class="input-label">Search the Name of your School</label>
                  <div class="school-search-wrapper">
                    <svg class="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="11" cy="11" r="8"></circle>
                      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search your school"
                      [value]="schoolSearchQuery"
                      [class.input-focused]="showSchoolDropdown"
                      [class.input-error]="submitted && !selectedSchool"
                      (input)="onSchoolSearch($event.target['value'])"
                      (focus)="showSchoolDropdown = true"
                      (blur)="hideDropdownDelayed()"
                      autocomplete="off"
                    />

                    <!-- Dropdown -->
                    <div class="school-dropdown" *ngIf="showSchoolDropdown">
                      <div class="school-dropdown__item" (click)="cantFindSchool()">
                        I Can&rsquo;t find my school
                      </div>
                      <ng-container *ngIf="isSearchingSchools">
                        <div class="school-dropdown__divider"></div>
                        <div class="school-dropdown__item text-muted">
                          <span class="spinner-border spinner-border-sm mr-1"></span> Searching&hellip;
                        </div>
                      </ng-container>
                      <ng-container *ngFor="let school of schoolResults">
                        <div class="school-dropdown__divider"></div>
                        <div class="school-dropdown__item" (click)="selectSchool(school)">
                          {{ school.name }}
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <small class="text-success" *ngIf="selectedSchool && selectedSchool.id > 0">
                    {{ selectedSchool.name }}
                  </small>
                  <small class="text-danger" *ngIf="submitted && !selectedSchool">
                    Please select your school
                  </small>
                </div>
              </div>
              </form>

              <div class="action-buttons">
                <button class="btn btn-proceed" (click)="proceedToContest()">
                  Proceed To Contest
                </button>
                <button class="btn btn-back" type="button" (click)="navigateBack()">
                  Back
                </button>
              </div>
            </div>

            <!-- Step: checking ─────────────────────────────────────────── -->
            <div class="beewiz-step beewiz-checking" *ngIf="step === 'checking'">
              <div class="checking-ring">
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
                  <circle cx="60" cy="60" r="50" stroke="#e8e8e8" stroke-width="8"/>
                  <circle cx="60" cy="60" r="50" stroke="#46af4d" stroke-width="8"
                    stroke-linecap="round" stroke-dasharray="314" stroke-dashoffset="235"
                    class="checking-arc"/>
                </svg>
              </div>
              <div class="checking-text-group">
                <p class="checking-title">Checking your subscription&hellip;</p>
                <p class="checking-subtitle">One moment while we see if you already have BeeWiz access.</p>
              </div>
            </div>

            <!-- Step: payment ──────────────────────────────────────────── -->
            <div class="beewiz-step payment-step" *ngIf="step === 'payment'">

              <!-- Header -->
              <div class="payment-header">
                <p class="payment-title">Almost There!</p>
                <p class="payment-subtitle">
                  Get Your {{ anonStatus?.amount || beewizPlan?.amount || 49 }}/=
                  Subscription To Enter competition
                </p>
              </div>

              <!-- Plan card -->
              <div class="plan-card">
                <div class="plan-card__top">
                  <div class="plan-card__info">
                    <p class="plan-card__name">Beewiz Plan</p>
                    <p class="plan-card__price">Ksh {{ anonStatus?.amount || beewizPlan?.amount || 49 }}</p>
                  </div>
                  <div class="plan-card__selected">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="11" stroke="#46af4d" stroke-width="2"/>
                      <circle cx="12" cy="12" r="5.5" fill="#46af4d"/>
                    </svg>
                  </div>
                </div>
                <div class="plan-card__divider"></div>
                <div class="plan-card__features">
                  <p class="plan-card__features-title">This plan includes:</p>
                  <ul class="plan-features-list">
                    <li class="plan-features-list__item">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="10" fill="#46af4d"/>
                        <path d="M5.5 10.5l3 3 6-6" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span>5 contests</span>
                    </li>
                    <li class="plan-features-list__item">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="10" fill="#46af4d"/>
                        <path d="M5.5 10.5l3 3 6-6" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span>3 months validity</span>
                    </li>
                    <li class="plan-features-list__item">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="10" fill="#46af4d"/>
                        <path d="M5.5 10.5l3 3 6-6" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span>Invite as many friends to your contest</span>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Subject selection -->
              <div class="subject-section">
                <p class="subject-note">Each subject has a different time slot so you can join all of them!</p>
                <p class="subject-label">Which Contest are you interested in competing in?</p>
                <div class="subject-grid">
                  <div
                    class="subject-item"
                    *ngFor="let subject of availableSubjects"
                    (click)="toggleSubject(subject)"
                    [class.subject-item--selected]="selectedSubjects.has(subject)"
                  >
                    <div class="subject-checkbox" [class.subject-checkbox--checked]="selectedSubjects.has(subject)">
                      <svg *ngIf="selectedSubjects.has(subject)" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M2 7l3.5 3.5L12 3" stroke="#46af4d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <span class="subject-item__label">{{ subject }}</span>
                  </div>
                </div>
              </div>

              <!-- Phone input -->
              <form [formGroup]="paymentForm">
                <div class="input-field-group">
                  <label class="input-label">Enter Phone Number</label>
                  <input
                    type="tel"
                    class="form-control"
                    placeholder="e.g. 254712345678"
                    formControlName="phone"
                    [class.input-error]="paymentForm.get('phone').touched && paymentForm.get('phone').invalid"
                  />
                  <small class="text-danger"
                    *ngIf="paymentForm.get('phone').touched && paymentForm.get('phone').errors?.required">
                    Phone number is required
                  </small>
                  <small class="text-danger"
                    *ngIf="paymentForm.get('phone').touched && paymentForm.get('phone').errors?.pattern">
                    Enter a valid Safaricom number starting with 254 (e.g. 254712345678)
                  </small>
                </div>
              </form>

              <!-- Retry badge -->
              <div *ngIf="paymentRetries > 0" class="retry-badge">
                Retry {{ paymentRetries }} of {{ maxRetries }}
              </div>

              <!-- Actions -->
              <div class="payment-actions">
                <button class="btn btn-cancel" type="button" (click)="backToEntry()">Cancel</button>
                <button class="btn btn-make-payment" (click)="makePayment()" [disabled]="paymentForm.invalid">
                  Make Payment
                </button>
              </div>
            </div>

            <!-- Step: polling ──────────────────────────────────────────── -->
            <div class="beewiz-step beewiz-polling" *ngIf="step === 'polling'">
              <div class="polling-icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                  <circle cx="32" cy="32" r="28" stroke="#46af4d" stroke-width="4" stroke-linecap="round"
                    stroke-dasharray="160" stroke-dashoffset="40" class="polling-ring" />
                  <path d="M20 32l8 8 16-16" stroke="#46af4d" stroke-width="4" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
              <p class="polling-title">Check your phone for M-Pesa prompt</p>
              <p class="polling-subtitle">
                Enter your M-Pesa PIN to complete payment
                <span *ngIf="anonStatus?.amount"> of <strong>KES {{ anonStatus.amount }}</strong></span>
              </p>
              <p class="polling-dots">
                <span class="dot dot-1"></span>
                <span class="dot dot-2"></span>
                <span class="dot dot-3"></span>
              </p>
            </div>

          </ng-container>

          <!-- ── LOGGED-IN FLOW (existing) ─────────────────────────────── -->
          <ng-container *ngIf="contest?.contestId && !isAnonFlow">
            <div class="holder-container d-flex align-items-center flex-column mx-auto"
              [ngClass]="{'holder-container-logged': currentUser?.userId}">

              <div class="select-title p-2 mb-4 d-md-flex text-center text-md-left align-items-center justify-content-between">
                <img src="../../../../../assets/img/Group 40086.png" alt="" height="108px" class="mb-1 mb-md-0" />
                <div class="ml-md-2">
                  <p class="mb-1">
                    You are about to join a
                    <span>{{ contest.title }} {{ contest.difficultyLevel }} Quiz</span>
                  </p>
                  <p class="mb-0 contest-details">
                    Form {{ contest.form }}, {{ contest.subject }} - {{ contest.title }}
                  </p>
                  <p class="font-small-4 mb-0 font-weight-bold" *ngIf="contest.startDate">
                    Contest Time: {{ contest.startDate | customDate }}
                  </p>
                </div>
              </div>

              <p class="school-details text-center mb-2">
                {{ currentUser ? 'Click Continue to proceed to the quiz page' : 'Please enter your name below to continue' }}
              </p>

              <form [formGroup]="joinContestForm">
                <div class="text-danger" *ngIf="submitted && f.displayName.errors">
                  <p class="mb-0" *ngIf="f.displayName.errors?.required">Please provide your full name</p>
                </div>
                <div class="form-group mb-1">
                  <label for="code">Enter Full Name</label>
                  <input
                    id="code"
                    type="text"
                    class="form-control"
                    placeholder="John Doe"
                    formControlName="displayName"
                  />
                </div>
              </form>

              <button class="btn btn-primary btn-block mt-3 mb-4" (click)="joinContest()">
                {{ isGettingContestDetails ? 'Getting Contest Details' : 'Continue' }}
              </button>
            </div>
          </ng-container>

        </ng-container>
        <!-- end !isGettingContestDetails -->

      </div>
    </div>
  </div>
</div>
